import React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { Provider } from "react-redux";
import { store } from "./app/redux/Store";
// ROOT APP
import App from "./app/App";
import { jwtDecode } from "jwt-decode";
import { PublicClientApplication } from "@azure/msal-browser";
import { getConfiguration } from "./authConfig";

import "./styles/app/app.scss";
// import "./index.css";
//import "./index.scss";

var idToken = window.location.search.split('id_token_hint=')[1];

if (idToken != undefined && idToken != null) {
  const decoded = jwtDecode(idToken);
  sessionStorage.setItem('idTokenHint', idToken);
  sessionStorage.setItem('loginType', 'idTokenHint');
  sessionStorage.setItem('companyId', decoded.companyId);
}

// Force clear MSAL accounts/session if id_token_hint is present
async function clearMsalAccountsIfNeeded(pca) {
  if (idToken != undefined && idToken != null) {
    const accounts = pca.getAllAccounts();
    if (accounts && accounts.length > 0) {
      accounts.forEach(acc => pca.removeAccount(acc));
    }
  }
}

async function main() {
  const pca = await PublicClientApplication.createPublicClientApplication(getConfiguration());
  await clearMsalAccountsIfNeeded(pca);
  const root = createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={pca}>
        <Provider store={store}>
          <App pca={pca}/>
        </Provider>
      </MsalProvider>
    </React.StrictMode>
  );
}

main();
